import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useFetch } from "hooks";
import { get } from "utils/api";
import { message, errorMessage } from "actions/message";
import SearchableDropdown from "components/searchable-dropdown";
import FormikField from "components/forms/formik-field";
import { Formik } from "formik";
import PhoneNumberField from "components/forms/phone-number-field";
import { formatPhone } from "utils/misc";

const SynthpopTesting = () => {
  const dispatch = useDispatch();

  const initiateSynthpopCallApi = useFetch({
    apiFn: patientId =>
      get(`synthpop/initiate-call/${patientId}`).then(x => setCallSid(x))
  });

  const fetchSynthpopTaskApi = useFetch({
    apiFn: ({patientId, createOrder}) =>
      get(`synthpop/fetch-task-details/${patientId}/${createOrder}`).then(x => {
        setTaskInfo(x);
        if (x?.message) {
          dispatch(message(x.message));
        }
      })
  });

  const [usePhoneSearch, setUsePhoneSearch] = React.useState(true);
  const [manualGuid, setManualGuid] = React.useState("");
  const [selectedPatient, setSelectedPatient] = React.useState(null);
  const [patients, setPatients] = React.useState([]);
  const [callSid, setCallSid] = React.useState(null);
  const [fetchCallSid, setFetchCallSid] = React.useState("");
  const [taskInfo, setTaskInfo] = React.useState(null);
  const [createOrder, setCreateOrder] = React.useState(false);

  const getPatients = async e => {
    dispatch(message("Getting patients..."));
    try {
      const response = await get(`patients/ivr_test_patients/${e.phone}/Agent`);
      if (response && response.length > 0) {
        setSelectedPatient(response[0].patient_guid);
        dispatch(
          message(
            `Found ${response.length} patient${response.length === 1 ? "" : "s"}`
          )
        );
        setPatients(response);
      } else {
        dispatch(message("No patients found for this phone number"));
        setPatients([]);
        setSelectedPatient(null);
      }
    } catch (error) {
      dispatch(errorMessage("Error searching for patients"));
      setPatients([]);
      setSelectedPatient(null);
    }
  };


  return (
    <div>
      <h1>Synthpop Integration Testing</h1>

      <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '20px' }}>
        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <input
            type="radio"
            checked={usePhoneSearch}
            onChange={() => {
              setUsePhoneSearch(true);
              setManualGuid("");
              setSelectedPatient(null);
            }}
            style={{ marginRight: '8px' }}
          />
          Search by Phone Number
        </label>
        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <input
            type="radio"
            checked={!usePhoneSearch}
            onChange={() => {
              setUsePhoneSearch(false);
              setPatients([]);
              setSelectedPatient(null);
            }}
            style={{ marginRight: '8px' }}
          />
          Use Patient GUID
        </label>
      </div>

      {usePhoneSearch ? (
        <div>
          <h3>Search Patient by Phone Number</h3>
        <Formik
          onSubmit={(values) => {
            if (values.phone.length > 10) {
              dispatch(message("Phone must be shorter than 10 numbers"));
            } else {
              getPatients(values);
            }
          }}
          initialValues={{ phone: "" }}
        >
          {({ values }) => (
            <form>
              <FormikField
                name="phone"
                label="Phone Number:"
                type="tel"
                component={PhoneNumberField}
                placeholder="Search Patient By Phone Number"
              />
              <button
                disabled={values.phone.length < 10}
                onClick={() => {
                  getPatients(values);
                }}
                type="button"
              >
                Search
              </button>
            </form>
          )}
        </Formik>

        <div>
          Patients Found:
          <SearchableDropdown
            options={patients.map((x, i) => {
              return {
                text:
                  x.company_name +
                  " calling from " +
                  formatPhone(x.outbound_ivr_number || "N/A") +
                  " to " +
                  x.first_name +
                  " " +
                  x.last_name +
                  " at " +
                  formatPhone(x.patient_phone),
                value: x.patient_guid,
                key: x.patient_guid + i
              };
            })}
            selected={selectedPatient}
            onSelect={e => {
              setSelectedPatient(e);
            }}
          />
          {selectedPatient && patients.find(p => p.patient_guid === selectedPatient)?.patient_secondary_phone && (
            <div style={{ color: 'red', marginTop: '8px' }}>
              This patient has a secondary phone number: {patients.find(p => p.patient_guid === selectedPatient).patient_secondary_phone}. If the first call goes to voicemail, the secondary number will be called.
            </div>
          )}
        </div>
        </div>
      ) : (
        <div>
          <h3>Enter Patient GUID</h3>
          <input
            type="text"
            placeholder="Patient GUID"
            value={manualGuid}
            onChange={e => setManualGuid(e.target.value)}
            style={{ padding: '8px', marginRight: '10px', width: '300px' }}
          />
        </div>
      )}

      <div>
        <button
          onClick={() => initiateSynthpopCallApi.fetchData(usePhoneSearch ? selectedPatient : manualGuid)}
          disabled={usePhoneSearch ? !selectedPatient : !manualGuid}
        >
          Start Agent Call
        </button>
        {callSid ? <div>Call sid: {JSON.stringify(callSid)}</div> : ""}
      </div>

      <div>
        <h3>Fetch Synthpop Task</h3>
        <input
          type="text"
          placeholder="Call Sid"
          value={fetchCallSid}
          onChange={e => setFetchCallSid(e.target.value)}
        />
         <label>
          <input
            type="checkbox"
            checked={createOrder}
            onChange={e => setCreateOrder(e.target.checked)}
          />
          Create Order
        </label>
        <button
          onClick={() => fetchSynthpopTaskApi.fetchData({
            patientId: fetchCallSid || (usePhoneSearch ? selectedPatient : manualGuid),
            createOrder: createOrder
          })}
          disabled={!fetchCallSid && !selectedPatient && !manualGuid}
        >
          Submit
        </button>
        {taskInfo ? (
              <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
            <div style={{ marginTop: '10px' }}>
              <strong>Task Status:</strong> {taskInfo.taskStatus}
            </div>
            {taskInfo.orderCreated && (
              <div style={{ marginTop: '10px' }}>
                <strong>Order Created:</strong> Yes
              </div>
            )}
            {taskInfo.orderGuid && (
              <div style={{ marginTop: '10px' }}>
                <strong>Order:</strong>{' '}
                <Link to={`/orders/${taskInfo.orderGuid}`}>
                  View Order
                </Link>
              </div>
            )}
            {taskInfo.transcript && (
              <div style={{ marginTop: '10px' }}>
                <strong>Transcript:</strong>
                <div style={{ whiteSpace: "pre-wrap", marginTop: '5px' }}>
                  {taskInfo.transcript}
                </div>
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SynthpopTesting;
